import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';

export const ItemAction = styled.a`
  color: ${Color.CLOUD_BURST};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.S};
  font-weight: ${({ isMobile }) =>
    isMobile ? FontWeight.BLACK : FontWeight.REGULAR};
  letter-spacing: 0;
  line-height: 19px;
  min-width: 55px;
  min-height: 45px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  outline: none;
  box-sizing: border-box;

  &:hover {
    background-color: ${({ isMobile }) =>
      isMobile ? Color.WHITE : Color.WHISPER};
  }

  &:focus-visible {
    border: 2px solid ${Color.CLOUD_BURST};
    border-radius: 5px;
  }
`;

export const Item = styled.div`
  display: ${({ isMobile }) => (isMobile ? 'inline-block' : 'flex')};
  flex-direction: ${({ isMobile }) => (isMobile ? 'initial' : 'column')};
`;

export const SelectedItemAction = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${Color.CLOUD_BURST};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.S};
  font-weight: ${FontWeight.BLACK};
  letter-spacing: 0;
  line-height: 19px;
  background: none;
  border: none;
  outline: none;
  box-sizing: border-box;

  svg {
    display: ${({ hasNoAltLang }) => (hasNoAltLang ? 'none' : 'block')};
    transition: ${({ isOpen }) => isOpen && `all 0.20s ease`};
    transform: ${({ isOpen }) => isOpen && `translate(25%) rotate(-180deg)`};
    padding-left: 10px;
  }

  &:focus-visible {
    border: 2px solid ${Color.CLOUD_BURST};
  }
`;

export const SelectedItem = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 45px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '77px')};
  box-sizing: border-box;
  border-radius: 10px;
  background-color: ${({ isOpen }) => (isOpen ? Color.WHISPER : Color.WHITE)};
  border: ${({ isOpen, isMobile }) =>
    isOpen || isMobile
      ? '2px solid transparent;'
      : `2px solid ${Color.MYSTIC}`};

  button {
    ${props =>
      props.isMobile &&
      `
      display: flex;
      justify-content: space-between;
      width: 100%;
    `};
  }
`;
